import { parseZonedDateTime } from '@internationalized/date';
import { maybeParseZonedDateTime } from '@rematter/common/dateTime';
import { RouteStatus } from '@rematter/frontend-lib-api-client';

import { SERVICE_FRAGMENT } from '../@shared-fragments/serviceFragment';
import { mapService } from '../@shared-mappers/mapService';
import { useLoadBoardServicesQuery } from '../queries/useLoadBoardServicesQuery';

import { createMutationHook } from '~/shared/providers/api';

export const useRouteTransitionMutation = createMutationHook(
  'transportation.routeTransition',
  (params: { id: string; status: RouteStatus; notes?: string }) => ({
    transportationRouteTransition: {
      __args: {
        id: params.id,
        status: params.status,
        notes: params.notes,
      },
      id: true,
      description: true,
      status: true,
      documentNumber: true,
      routeDate: true,
      startedAt: true,
      completedAt: true,
      driverId: true,
      facilityGroupId: true,
      driver: {
        id: true,
        firstName: true,
        lastName: true,
      },
      services: SERVICE_FRAGMENT,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    invalidateQueries: [useLoadBoardServicesQuery],
    select: ({ transportationRouteTransition: route }) => ({
      id: route.id,
      description: route.description,
      status: route.status,
      documentNumber: route.documentNumber,
      routeDate: maybeParseZonedDateTime(route.routeDate),
      startedAt: maybeParseZonedDateTime(route.startedAt),
      completedAt: maybeParseZonedDateTime(route.completedAt),
      driverId: route.driverId ?? undefined,
      facilityGroupId: route.facilityGroupId,
      driver: route.driver ?? undefined,
      services: route.services.map(mapService),
      timestamps: {
        createdAt: parseZonedDateTime(route.timestamps.createdAt),
        updatedAt: parseZonedDateTime(route.timestamps.updatedAt),
      },
    }),
  },
);
